export const hasMotdCookie = (version) => {
  return document.cookie.split('; ').find(c => c.startsWith(`commons_motd_${version}=`)) !== undefined;
};
export const setMotdCookie = (version) => {
  document.cookie = `commons_motd_${version}=true; path=/; max-age=2592000; SameSite=None; Secure`;
};
